import React from 'react'

 function BlockTwo() {
    
    return (
     
        <div class="row antrasblokas d-flex  sonai text-white ">

          <div class="col-12 pav1 text-center"> <p > PASLAUGOS</p></div>
          <div className="col-12"> <hr className="text-white-50"/></div>
          <div class="col-12 pav2"> Turiu 2 m. turinio valdymo sistemų diegimo, pritaikymo pagal kliento poreikius ir priežiūros patirtį. Esu teikęs el. prekybos ir e-marketingo paslaugas. Klientai: UAB "Kelionių akademija", Unipark.lt, ADCParking ir kt.  </div>
          
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 .col-xl-3  pr-3 pl-3">
            <img class="row antrasblokas border-0  img-thumbnail  m-auto justify-content-center " src="/pic/web.png"  alt="pirmas"/>
            <div class="row  justify-content-center text-center pt-5 pb-5"><h5>TINKLAPIŲ KŪRIMAS</h5></div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-3 .col-xl-3 pr-3 pl-3">
            <img class="row antrasblokas border-0  img-thumbnail  m-auto justify-content-center " src="/pic/shop.png"  alt="pirmas"/>
            <div class="row  justify-content-center text-center pt-5 pb-5"><h5>EL. PARDUOTUVIŲ KŪRIMAS</h5></div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-3 .col-xl-3 pr-3 pl-3 ">
            <img class="row antrasblokas border-0  img-thumbnail  m-auto justify-content-center " src="/pic/maket.png"  alt="pirmas"/>
            <div class="row  justify-content-center text-center pt-5 pb-5"><h5>MAKETAVIMAS</h5></div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-3 .col-xl-3 pr-3 pl-3">
            <img class="row antrasblokas border-0  img-thumbnail  m-auto justify-content-center " src="/pic/mark.png"  alt="pirmas"/>
            <div class="row  justify-content-center text-center pt-5 pb-5"><h5>E-MARKETINGO PASLAUGOS</h5></div>
          </div>

        </div>
    )
}
export default BlockTwo